import React from "react";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import { StyledCol, StyledTableRow } from "../../styles/styledTable";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { StyledBreakWord } from "../../styles/styledBreakWord";
import { StyledCopy } from "../../styles/styledCopy";
import RenderStatus from "../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

const TransferItem = ({ transfer, notification, setNotification }) => {
  const { t } = useTranslation("transferPage");

  return (
    <StyledTableRow
      scroll="auto"
      col="10"
      className="transfer-table__row"
    >
      <StyledCol
        inline
        data-title="id"
      >
        <CopyToClipboard
          text={transfer.id}
          onCopy={() => {
            setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
          }}
        >
          <StyledBreakWord as="p">
            {transfer.id} <StyledCopy
            title={t("table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol
        inline
        data-title={t("table.senderEmail")}
      >
        <CopyToClipboard
          text={transfer.sender?.email || ""}
          onCopy={() => {
            setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
          }}
        >
          <StyledBreakWord as="p">
            {transfer.sender
              ? (transfer.sender.nickname ? transfer.sender.nickname + ": " : "") + transfer.sender.email
              : "--"} <StyledCopy
            title={t("table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol
        inline
        data-title={t("table.receiverEmail")}
      >
        <CopyToClipboard
          text={transfer.receiver?.email || ""}
          onCopy={() => {
            setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
          }}
        >
          <StyledBreakWord as="p">
            {transfer.receiver
              ? (transfer.receiver.nickname ? transfer.receiver.nickname + ": " : "") + transfer.receiver.email
              : "--"} <StyledCopy
            title={t("table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol data-title={t("table.service")}>
        {transfer.service
          ? getServiceNameWithNickname(transfer.service.name, transfer.service.nickname)
          : "--"}
      </StyledCol>
      <StyledCol data-title={t("table.currency")}>
        {transfer.currency?.asset}
      </StyledCol>
      <StyledCol data-title={t("table.amount")}>
        {transfer.amount}
      </StyledCol>

      <StyledCol
        inline
        data-title={t("table.status")}
      >
        {transfer.status ? <RenderStatus status={transfer.status.value} /> : "--"}
      </StyledCol>
      <StyledCol data-title={t("table.createdAt")}>
        {TimestampToDateMoment(transfer.createdAt)}
      </StyledCol>
      <StyledCol data-title={t("table.updatedAt")}>
        {TimestampToDateMoment(transfer.updatedAt)}
      </StyledCol>
      <StyledCol data-title={t("table.note")} className="transfer-table__note">
        {transfer.note}
      </StyledCol>
    </StyledTableRow>
  );
};

export default TransferItem;